module.exports = __webpack_public_path__ + "static/cashew_nuts_td_2-372516f0296028629a97b0d306da900e.jpg";